import React from 'react'
import ScreensLayout from './ScreensLayout'

const Screens = () => {
  return <ScreensLayout />
}
export default Screens
